import React from "react";
import { Box, List, Divider, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import MenuListItem from "../shared/menuListItem";

const CategoryMenuLevel2 = ({
                                title,
                                icon,
                                items = [],
                                onBack,
                                onClose,
                                onItemClick,
                            }) => {
    const [hoveredIndex, setHoveredIndex] = React.useState(null);
    const [headerHovered, setHeaderHovered] = React.useState(false);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "20px",
                }}
            >
                <IconButton
                    onClick={onClose}
                    size="large"
                    sx={{
                        color: "#111",
                        bgcolor: "#ffffff",
                        borderRadius: "50px",
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box
                onClick={onBack}
                onMouseEnter={() => setHeaderHovered(true)}
                onMouseLeave={() => setHeaderHovered(false)}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    p: 1.5,
                    bgcolor: "#E9E9E9",
                    transition: "all 0.3s ease",
                    "&:hover": {
                        backgroundColor: "#E9E9E9",
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                    }}
                >
                    <IconButton
                        sx={{
                            color: headerHovered ? "#e5007e" : "#111",
                            transition: "color 0.3s ease",
                            "&:hover": {
                                backgroundColor: "transparent",
                            },
                        }}
                    >
                        <ArrowBackIosNewIcon sx={{ fontSize: "20px" }} />
                    </IconButton>

                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 900,
                            fontSize: "14px",
                            textTransform: "uppercase",
                            fontFamily: "Zen Maru Gothic",
                            color: headerHovered ? "#e5007e" : "#111",
                            lineHeight: "1.1",
                            transition: "color 0.3s ease",
                        }}
                    >
                        {title}
                    </Typography>
                </Box>

                {!!icon && (
                    <img
                        src={icon}
                        width="34px"
                        alt={title}
                        style={{
                            filter: headerHovered
                                ? "brightness(0) saturate(100%) invert(13%) sepia(98%) saturate(2000%) hue-rotate(315deg)"
                                : "none",
                            transition: "filter 0.3s ease",
                        }}
                    />
                )}
            </Box>

            <Divider
                sx={{
                    backgroundColor: "#949494ff",
                    margin: "0px",
                }}
            />

            <List
                sx={{
                    flex: 1,
                    overflow: "auto",
                    padding: 0,
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    "&::-webkit-scrollbar": {
                        display: "none",
                    },
                }}
            >
                {items.map((item, index) => (
                    <React.Fragment key={item.id ?? index}>
                        <Box
                            onClick={() => onItemClick(item)}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                            sx={{ cursor: "pointer" }}
                        >
                            <MenuListItem
                                icon={item.icon}
                                name={item.name}
                                isHighlight={item.highlight || false}
                                isHovered={hoveredIndex === index}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                hasSubmenu={item.hasSubmenu}
                            />
                        </Box>

                        {index < items.length - 1 && (
                            <Divider
                                sx={{
                                    backgroundColor: "#b9b9b9",
                                    margin: "0px",
                                }}
                            />
                        )}
                    </React.Fragment>
                ))}
            </List>
        </Box>
    );
};

export default CategoryMenuLevel2;